/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-06 14:27:22
 * @Description: 
 */
import { message } from "antd";
import { autorun } from "mobx";
import React from "react"
import FTAnalytic from "src/analyze/FTAnalytic";
import { IconDownload, IconHighD, IconPlus, IconPreview, IconVip } from "src/assets";
import FTButton from "src/components/FTButton/FTButton";
import FTDownloadSize from "src/components/FTDownloadSize/FTDownloadSize";
import FTWatermark from "src/components/FTWatermark/FTWatermark";
import imageProcesserSize from "src/constant/imageProcesserSize";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTImageStore from "src/store/FTImageStore";
import FTUserStore from "src/store/FTUserStore";
import utils from "src/utils";
import FTLang from "src/utils/FTLang";
interface IProps {
  drawCanvasResize: () => void,
  download: () => void,
}
class FTCanvasPanel extends React.Component<IProps, {}> {
  state = {
    showDownload: false,
    showWaterMark: false,
    smallSize: {
      width: 0,
      height: 0
    },
    largerSize: {
      width: 0,
      height: 0
    },
    isMobile: false
  }
  componentDidMount() {
    autorun(() => {
      let { showDownload, isMobile } = FTCanvasStore
      let { isVip } = FTUserStore
      let { currentEffect, currentSize, acturalSize } = FTImageStore
      let smallScale = utils.aspectFitScale(currentSize.width, currentSize.height, imageProcesserSize.IMAGE_SIDE_VALUE)
      let largerScale = utils.aspectFitScale(acturalSize.width, acturalSize.height, Number(imageProcesserSize.SUPPER_RESOLUTION_HIGH_ID))
      
      this.setState({
        showDownload,
        showWaterMark: !isVip && currentEffect,
        smallSize: {
          width: Math.round(currentSize.width * smallScale),
          height: Math.round(currentSize.height * smallScale)
        },
        largerSize: {
          width: Math.round(acturalSize.width * largerScale),
          height: Math.round(acturalSize.height * largerScale)
        },
        isMobile
      })
    })
  }
  
  changeImage = async () => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$show$goart_import_image',
      label: {
        position: "goart_change_image"
      }
    })
    let img = await utils.selectImageFile({multiple: false})
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$close$goart_import_image',
      label: {
        position: "goart_change_image"
      }
    })
    if(img && img.length > 0) {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_import_image',
        label: {
          position: "goart_change_image",
          is_success: true
        }
      })
      FTCanvasStore.changeLoading(true)
      if(!utils.checkFileType(img[0])) {
        message.error(FTLang._("goart_image_upload_errror"))
        FTCanvasStore.changeLoading(false)
        return
      }
      let {canvas: imageElement, acturalSize, currentSize} = await utils.getImageFromFile(img[0]);
      FTImageStore.setCurrentImageElement(imageElement, currentSize, acturalSize)
      FTImageStore.setCurrentImage(img[0])
      this.props.drawCanvasResize()
      FTCanvasStore.changeLoading(false)
      if(FTImageStore.currentEffect && FTImageStore.currentEffect !== "original") {
        
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$click_up$goart_project_effects',
        label: {
          resource_id: utils.toFixed(FTImageStore.currentEffect.id, 0),
          resource_name: FTImageStore.currentEffect.name,
        }
      })
        FTImageStore.getGoartEffect(FTImageStore.currentEffect)
      }
    } else {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_import_image',
        label: {
          position: "goart_change_image",
          is_success: false
        }
      })
    }
  }
  handleDownload = () => {
    this.props.download()
  }
  

  
  render() {
    let { isMobile } = this.state
    return <div className="canvas_panel" onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
    }}>
      <FTButton className="canvas_panel_open" onClick={() => this.changeImage()}>
        <IconPlus />
        <span>
          {FTLang._("goart_change_image")}
        </span>
      </FTButton>
      {isMobile && <FTWatermark theme="text" />}
      <div className="canvas_panel_right">
        {!isMobile && <FTDownloadSize theme="light"/>}
        <div className="canvas_panel_download">
          <FTButton className="canvas_panel_download_btn" type="primary" onClick={() => this.handleDownload()}>
            <IconDownload />
            <span>
              {FTLang._("goart_download")}
            </span>
          </FTButton>
        </div>
      </div>
    </div>
  }
}

export default FTCanvasPanel